/**
 * Central gate for agentic Picks debug UI and diagnostic logging (Right Now, Services, Vets).
 * Default off in all environments; set NEXT_PUBLIC_PICKS_DEBUG=true to enable.
 */
export function isPicksDebugEnabled(): boolean {
  if (typeof process === 'undefined') return false
  return process.env.NEXT_PUBLIC_PICKS_DEBUG === 'true'
}
